import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "services/api";
import { ResumedView } from "./ResumedView";
import { IMovimentacao, ViewMode } from "../types";
import { DetailedView } from "./DetailedView";
import { RetificarView } from "./RetificarView";

export function View() {
  const { workspaceId, templateId } = useParams() as { workspaceId: string, templateId: string };
  const [view, setView] = useState<ViewMode>("RESUMED");

  function handleChangeView(newView: ViewMode) {
    setView(newView);
  }

  const { data, isFetching, isFetched, isError } = useQuery({
    queryKey: ["movimentacao", workspaceId, templateId],
    queryFn: () =>
      api.get(
        `/v2/workspaces/${workspaceId}/templates/${templateId}/movimentacao-export`
      ),
    select: (data) => data.data.data as IMovimentacao,
    refetchInterval: 5000
  });

  return (
    <>
      {!isFetched && isFetching && <div>Loading...</div>}
      {!isFetched && isError && <div>Error...</div>}
      {data && view === "RESUMED" && (
        <ResumedView
          movimentacao={data.movimentacao}
          template={data.template}
          setViewMode={handleChangeView}
        />
      )}
      {data && view === "DETAILED" && (
        <DetailedView
          template={data.detailedView}
          setViewMode={handleChangeView}
        />
      )}
      {data && view === "RETIFICAR" && (
        <RetificarView
          movimentacao={data.movimentacao}
          template={data.template}
          setViewMode={handleChangeView}
        />
      )}
    </>
  );
}
